import NextLink from 'next/link';

export interface LinkProps {
  ariaLabel?: string;
  href: string;
  leadingIcon?: React.ReactNode;
  style?: string;
  target?: string;
  title: string;
}

const Link: React.FC<LinkProps> = ({
  ariaLabel,
  href,
  leadingIcon,
  style,
  target,
  title,
}) => {
  return href.startsWith('/') ? (
    <NextLink
      data-testid="next-link"
      className={style}
      href={href}
      target={target}
      aria-label={ariaLabel}
    >
      {leadingIcon}
      {title}
    </NextLink>
  ) : (
    <a
      data-testid="a-link"
      aria-label={ariaLabel}
      className={style}
      href={href}
      target={target}
    >
      {leadingIcon}
      {title}{' '}
    </a>
  );
};

export default Link;
